import styled from "styled-components";

import { device } from "../../../services";
import { FlexContainers } from "../../../components";
import { IconButtonStyled } from "../../Buttons/styled";

export const Step1Wrapper = styled(FlexContainers.FlexRowStart)`
  ${IconButtonStyled} {
    height: 56px;
  }

  img#google-authenticator-app {
    width: 160px;
    height: 160px;
  }

  @media screen and ${device.mobile} {
    flex-direction: column;
  }
`;

export const ButtonsWrapper = styled(FlexContainers.FlexColumnCenter)`
  gap: 24px;
  height: 100%;
  margin-left: 24px;

  @media screen and ${device.mobile} {
    margin-top: 22px;
    margin-left: unset;
    gap: 16px;
  }
`;

export const Step2Wrapper = styled(FlexContainers.FlexRowCenter)`
  flex-wrap: wrap;
  width: 100%;

  img {
    width: 50%;
    object-fit: contain;

    @media screen and (max-width: 520px) {
      width: 100%;
    }
  }
`;
